import {
  AnonymousContextSource,
  AnonymousExecutionContext,
  AuthenticatedContextSource,
  AuthenticatedExecutionContext,
  AuthenticatedProfileId,
  AuthenticatedRole,
  BusinessDomain,
  AnonymousProfileId,
} from './execution-context.types';

function normalize(value: unknown): string {
  return String(value ?? '').trim().toUpperCase();
}

function isPlantOperator(value: unknown): boolean {
  return normalize(value) === '1';
}

export function resolveAuthenticatedContext(
  source: AuthenticatedContextSource
): AuthenticatedExecutionContext {
  const isHormigon = normalize(source.rol) === 'MIXER';
  const role: AuthenticatedRole = isPlantOperator(source.operadorDePlanta)
    ? 'operador-planta'
    : 'mixer';
  const business: BusinessDomain = isHormigon ? 'hormigon' : 'aridos';
  const profileId = resolveAuthenticatedProfileId(business, role);

  return {
    channel: 'authenticated',
    business,
    role,
    profileId,
  };
}

export function resolveAuthenticatedProfileId(
  business: BusinessDomain,
  role: AuthenticatedRole
): AuthenticatedProfileId {
  if (business === 'hormigon' && role === 'mixer') return 'HORMIGON_MIXER';
  if (business === 'hormigon') return 'HORMIGON_OPERADOR_PLANTA';
  if (role === 'mixer') return 'ARIDOS_MIXER';
  return 'ARIDOS_OPERADOR_PLANTA';
}

/**
 * CEMAR representa Cemento + Áridos en el flujo QR y, para este frontend,
 * se normaliza como Áridos. Los valores no CEMAR se mantienen como Hormigón
 * para conservar el comportamiento del enlace anónimo existente.
 */
export function resolveAnonymousBusiness(rol: unknown): BusinessDomain {
  const value = normalize(rol);
  return value === 'CEMAR' || value === 'ARIDO' || value === 'ARIDOS'
    ? 'aridos'
    : 'hormigon';
}

export function resolveAnonymousContext(
  source: AnonymousContextSource
): AnonymousExecutionContext {
  const business = resolveAnonymousBusiness(source.rol);
  const profileId: AnonymousProfileId =
    business === 'hormigon' ? 'ANONIMO_HORMIGON' : 'ANONIMO_ARIDOS';

  return {
    channel: 'anonymous',
    business,
    profileId,
    authorizedTicket: source.authorizedTicket ?? null,
    token: source.token ?? null,
    expiresAt: source.expiresAt ?? null,
    permissions: [...(source.permissions ?? [])],
  };
}
